export default "__VITE_ASSET__24rm5RlF__"